import type { JSX } from "react";
import { useVoiceRecorder } from "../../hooks/useVoiceRecorder";

interface VoiceMicButtonProps {
  onTranscription: (text: string) => void;
}

export function VoiceMicButton({ onTranscription }: VoiceMicButtonProps): JSX.Element {
  const { state, error, toggleRecording } = useVoiceRecorder();

  const onClick = (): void => {
    void toggleRecording().then((text) => {
      if (text !== null && text.length > 0) onTranscription(text);
    });
  };

  const title =
    state === "recording" ? "停止录音" : state === "processing" ? "转写中…" : "语音输入";

  return (
    <div className="mic-wrap">
      <button
        type="button"
        onClick={onClick}
        disabled={state === "processing"}
        className={`mic-btn mic-${state}`}
        title={title}
        aria-label={title}
      >
        {state === "processing" ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="spin"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        ) : (
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
            <line x1="12" y1="19" x2="12" y2="23" />
            <line x1="8" y1="23" x2="16" y2="23" />
          </svg>
        )}
      </button>
      {error !== null && <div className="mic-error">{error}</div>}
    </div>
  );
}
